import React from 'react';
import PollView from '../../../PollView';
import { FullViewProps } from '../types';

// TODO: merge PollView into this
export const PollFullView: React.FC<FullViewProps> = ({ deviation }) => {
  return <PollView deviation={deviation} />;
};
PollFullView.displayName = 'PollFullView';

export default PollFullView;
